<div id="gcc-footer">
  <div class="container">
    <div class="row">

      <!-- COLUNAS DINÂMICAS DO FOOTER -->
      <ng-container *ngFor="let f of footer">
        <div *ngIf="f[getKey(f)]?.length > 0" class="col justify-content-center mb-4 gcc-links1">
          <h3>
            {{ getKey(f) }}
          </h3>

          <div *ngFor="let i of f[getKey(f)]">
            <span *ngIf="i.descricao">
              {{ i.descricao }}
            </span>

            <simple-html *ngIf="
                !MISC.fotterProps?.socialMedia &&
                i.codigoHTML
              " [whiteSpace]="false" [html]="i.codigoHTML"></simple-html>
          </div>
        </div>
      </ng-container>


      <!-- REDES SOCIAIS -->
      <div *ngIf="
          !MISC.fotterProps?.socialMedia &&
          midiasSociais
        " class="col justify-content-center mb-4 gcc-links1">
        <simple-html [whiteSpace]="false" [html]="midiasSociais"></simple-html>
      </div>


      <!-- INSTITUCIONAL 1 -->
      <div *ngIf="hasGroup(1)" class="col justify-content-center mb-4 gcc-links2">
        <!-- <h3>{{ institucionalTitle1 }}</h3> -->
        <ng-container *ngIf="institucionalTitle1">
          <simple-html *ngIf="isHtml(institucionalTitle1); else textoSimples" [whiteSpace]="false"
            [html]="institucionalTitle1">
          </simple-html>

          <ng-template #textoSimples>
            <h3>{{ institucionalTitle1 }}</h3>
          </ng-template>
        </ng-container>

        <div *ngFor="let l of values | filterByKey : 'groupId' : 1">
          <a [routerLink]="['info', l.pageId]">
            {{ l.label }}
          </a>
        </div>
      </div>


      <!-- INSTITUCIONAL 2 -->
      <div *ngIf="institucionalTitle2 && institucionalTitle2.length > 0 && hasGroup(2)"
        class="col justify-content-center mb-4 gcc-links2">
        <!-- <h3>{{ institucionalTitle2 }}</h3> -->

        <ng-container *ngIf="institucionalTitle2">
          <simple-html *ngIf="isHtml(institucionalTitle2); else textoSimples" [whiteSpace]="false"
            [html]="institucionalTitle2">
          </simple-html>

          <ng-template #textoSimples>
            <h3>{{ institucionalTitle2 }}</h3>
          </ng-template>
        </ng-container>

        <div *ngFor="let l of values | filterByKey : 'groupId' : 2">
          <a [routerLink]="['info', l.pageId]">
            {{ l.label }}
          </a>
          <!-- 
          <simple-html
            *ngIf="!MISC.fotterProps?.socialMedia && l.label"
            [whiteSpace]="false"
            [html]="l.label"
          ></simple-html> -->
        </div>
      </div>

      <!-- MARKETING -->
      <div *ngIf="
          MISC.fotterProps?.marketingInforma?.enable &&
          MISC.fotterProps?.marketingInforma?.name
        " class="col-lg-2 mb-4 gcc-links2">
        <ng-container *ngIf="MISC.fotterProps?.marketingInforma?.titulo">
          <simple-html *ngIf="isHtml(MISC.fotterProps?.marketingInforma?.titulo); else textoSimples" [whiteSpace]="false"
            [html]="MISC.fotterProps?.marketingInforma?.titulo">
          </simple-html>

          <ng-template #textoSimples>
            <h3>Marketing</h3>
          </ng-template>
        </ng-container>
        <div>
          <a routerLink="marketing/catalog">
            {{ MISC.fotterProps.marketingInforma.name }}
          </a>
        </div>
      </div>

        <!-- ONDE ESTAMOS -->
      <div *ngIf="ondeEstamos && ondeEstamos.length > 0" class="col justify-content-center mb-4">
        <simple-html [whiteSpace]="false" [html]="ondeEstamos"></simple-html>
      </div>

    </div>


    <!-- REDES SOCIAIS - WIDE -->
    <simple-html *ngIf="
        MISC.fotterProps?.socialMedia?.position === 'wide' &&
        midiasSociais
      " [whiteSpace]="false" [html]="midiasSociais"></simple-html>

  </div>
</div>


<!-- COPYRIGHT -->
<div *ngIf="mostraCopyright" class="row justify-content-center">
  <div class="text-center p-4 col-md-2" style="color: #888; font-size: 0.7rem; margin-top: 18px" i18n>
    <a href="http://www.agilb2b.com.br/" target="blank" style="margin-bottom: 5px">
      <img src="assets/logo-agilb2b.png" title="PraticoCard" class="pb-1" style="width: 90px" />
    </a>

    <br />

    Ágil B2B<br />
    Solução definitiva para B2B.<br />
    ÁgilB2B © 2020 - Todos os direitos reservados.
  </div>


  <div class="text-center p-4 col-md-2" style="color: #888; font-size: 0.7rem" i18n>
    <a href="http://praticocard.com.br/" target="blank">
      <img src="assets/logo-parceiro.png" title="PraticoCard" class="pb-1" style="width: 75px" />
    </a>

    <br />

    Prático Card<br />
    Seu conciliador de cartões prático.<br />
    Prático Card © 2020 - Todos os direitos reservados.
  </div>
</div>